import { render, staticRenderFns } from "./GameCut.vue?vue&type=template&id=33862cb5"
import script from "./GameCut.vue?vue&type=script&lang=js"
export * from "./GameCut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports